"use client";

import { useBag } from "@repo/ui/bag";
import { PRODUCT_QUANTITY_LIMITS } from "@/constants/product-collections";

export type QuantityLimitResult =
  | { hasLimit: false }
  | {
      hasLimit: true;
      limit: number;
      currentCount: number;
      isAtLimit: boolean;
      maxSelectableQuantity: number;
    };

export const useQuantityLimit = (
  productId: number,
  bagItemId?: string,
): QuantityLimitResult => {
  const { bagItems } = useBag();

  const limit = PRODUCT_QUANTITY_LIMITS[productId];

  if (limit === undefined) {
    return { hasLimit: false };
  }

  const currentCount = bagItems.reduce((total, item) => {
    if (item.productId !== productId) return total;
    if (bagItemId && item.id === bagItemId) return total;
    return total + item.quantity;
  }, 0);

  return {
    hasLimit: true,
    limit,
    currentCount,
    isAtLimit: currentCount >= limit,
    maxSelectableQuantity: Math.max(0, limit - currentCount),
  };
};
